import type { Navigation } from '@toolpad/core/AppProvider';
import CalcIcon from 'icons/CalcIcon';
import DashboardIcon from 'icons/DashboardIcon';
import PatientsIcon from 'icons/PatientsIcon';
import PersonAddIcon from 'icons/PersonAddIcon';
import RegistriesIcon from 'icons/RegistriesIcon';
import UsersIcon from 'icons/UsersIcon';
import UsersIconOutline from 'icons/UsersIconOutline';

export const NAVIGATION: Navigation = [
  {
    kind: 'header',
    title: 'Main menu',
  },
  {
    segment: 'dashboard',
    title: 'Dashboard',
    icon: <DashboardIcon size={14} style={{ color: 'inherit' }} />,
  },
  {
    segment: 'registries',
    title: 'Registries',
    icon: <RegistriesIcon size={15} style={{ color: 'inherit' }} />,
    children: [
      {
        segment: 'all-registries',
        title: 'All Registries',
      },
      {
        segment: 'my-registries',
        title: 'My Registries',
      },
      {
        segment: 'shared-registries',
        title: 'Shared Registries',
      },
      {
        segment: 'new-registry',
        title: 'Create Registry',
      },
    ],
  },
  {
    segment: 'rvus-calculator',
    title: 'RVU Calculator',
    icon: <CalcIcon size={15} style={{ color: 'inherit' }} />,
  },
  {
    segment: 'users',
    title: 'Users',
    icon: <UsersIconOutline size={16} style={{ color: 'inherit' }} />,
  },
  {
    segment: 'patients',
    title: 'Patients',
    icon: <PatientsIcon size={16} style={{ color: 'inherit' }} />,
    children: [
      {
        segment: 'all-patients',
        title: 'All Patients',
      },
      {
        segment: 'add',
        title: 'Add Patient',
      },
    ],
  },
];
